function scrollTo(elem){
    var top = elem.offset().top - 92;

    $('body,html').animate({scrollTop: top}, 700);
}